module.exports = __webpack_public_path__ + "static/assets/078913b35aac1a33bb371ce73a276e22.gif";